import request1 from '@/utils/request1';

export function getNotifications(params) {
  return request1({ url: '/notifications', method: 'get', params });
}

export function getNotificationUnreadCount() {
  return request1({ url: '/notifications/unread-count', method: 'get' });
}

export function readNotification(noticeId) {
  return request1({ url: '/notifications/read', method: 'post', data: { notice_id: noticeId } });
}

export function readSystemNotification(type, readKey) {
  return request1({
    url: '/notifications/system/read',
    method: 'post',
    data: { type, read_key: readKey },
  });
}

export function readAllNotifications() {
  return request1({ url: '/notifications/read-all', method: 'post' });
}
